import { render, staticRenderFns } from "./ConveniosPorVencer.vue?vue&type=template&id=12d1c67e&scoped=true"
import script from "./ConveniosPorVencer.vue?vue&type=script&lang=js"
export * from "./ConveniosPorVencer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d1c67e",
  null
  
)

export default component.exports